export { BufferedPageContextDiscriminant, createBufferedPageContext, createPageContext, getDefaultBufferedPageContext, getDefaultPageContext, isBufferedPageContext, } from '@segment/analytics-page-tools';
export * from './add-page-context';
//# sourceMappingURL=index.js.map